const styles = () => ({
  socialLink: {
    color: '#5786D7',
    width: 18,
    height: 18,
    display: 'block',
    margin: '0 32px 0 0',
  },
});

export default styles;
